import { Link } from 'react-router-dom';
import { articles } from '@/mocks/asmr';

const articleImages: string[] = [
  'https://readdy.ai/api/search-image?query=Peaceful%20bedroom%20at%20night%20with%20soft%20moonlight%20and%20warm%20bedside%20lamp%2C%20cozy%20bedding%2C%20gentle%20shadows%2C%20tranquil%20sleep%20atmosphere%2C%20minimalist%20interior%2C%20cream%20and%20warm%20beige%20tones&width=400&height=280&seq=article-01-img&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Abstract%20sound%20wave%20visualization%20in%20warm%20soft%20colors%2C%20gentle%20gradients%20in%20cream%20and%20pink%2C%20calming%20audio%20visualizer%20art%2C%20minimalist%20design&width=400&height=280&seq=article-02-img&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Person%20relaxing%20with%20headphones%20in%20cozy%20living%20room%2C%20warm%20afternoon%20sunlight%2C%20peaceful%20home%20atmosphere%2C%20minimalist%20interior%2C%20cream%20and%20beige%20tones&width=400&height=280&seq=article-03-img&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Misty%20forest%20with%20soft%20sunlight%20through%20trees%2C%20gentle%20rain%20on%20leaves%2C%20peaceful%20nature%20scene%2C%20tranquil%20woodland%2C%20warm%20earthy%20tones%2C%20editorial%20landscape&width=400&height=280&seq=article-04-img&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Zen%20meditation%20space%20with%20candles%20and%20incense%2C%20wooden%20floor%2C%20minimalist%20Japanese%20interior%2C%20peaceful%20atmosphere%2C%20soft%20natural%20light%2C%20cream%20and%20earthy%20tones&width=400&height=280&seq=article-05-img&orientation=landscape',
];

export default function ArticleListSection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 lg:px-8 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            ASMR科普文章
          </h2>
          <p className="text-foreground-500 text-sm">了解更多关于ASMR的知识与使用技巧</p>
        </div>

        <div className="space-y-5">
          {articles.map((article, idx) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col sm:flex-row gap-5 p-5 rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full sm:w-48 h-36 sm:h-32 flex-shrink-0 rounded-xl overflow-hidden">
                <img
                  src={articleImages[idx]}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2 flex-wrap">
                  <span className="inline-block px-2 py-0.5 bg-primary-100 text-primary-700 rounded-full font-medium">
                    {article.categoryName}
                  </span>
                  <span>{article.date}</span>
                  <span>·</span>
                  <span>{article.readTime}阅读</span>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.summary}
                </p>
                <div className="mt-3 text-sm font-medium text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  阅读全文 <i className="ri-arrow-right-line ml-1"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}